import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "src/app/providers/navigation.service";
import { MatDialog } from "@angular/material/dialog";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { EmployeeChatComponent } from "src/app/shared/components/employee-chat/employee-chat.component";
import { AddNewEmployeeComponent } from "src/app/shared/components/add-new-employee/add-new-employee.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";

@Component({
  selector: 'sm-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit, OnDestroy {
  employeeData: any = []
  employeeCountData: any = []
  previousChatHash:any = null
  senderHashId:any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)
  receiverHashId:any
  constructor(
    private navservice: NavigationService,
 
    private router: Router,
    private _modelRef: MatDialog, 
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_DETAILS){
        this.employeeData = []
        if(resdata.result){
          this.receiverHashId = resdata.result[0].profile_hash_id
          this.employeeData = resdata.result
          this.employeeData[0].employee_address = typeof this.employeeData[0].employee_address == 'string' ? JSON.parse(this.employeeData[0].employee_address) : this.employeeData[0].employee_address 
        }
        this.loader = false
        this.loaderservice.showLoader = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_FEATURE_WISE_COUNT){
        this.employeeCountData = []
        if(resdata.result){
          this.employeeCountData = resdata.result
          // this.apiservice.getMessagesByID()
          this.apiservice.getEmployeeDetails(this.employeeHash)
        }
      
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE){
        // this.chatThreads = []
        if(resdata.result){

          resdata.result.forEach((element:any) => {
            if(element.senderInfo && element.receiverInfo){
              if(element.senderInfo && typeof element.senderInfo == 'string'){
                element.senderInfo = JSON.parse(element.senderInfo)
              }
              if(element.receiverInfo && typeof element.receiverInfo == 'string'){
                element.receiverInfo = JSON.parse(element.receiverInfo)
              }
              console.log(this.senderHashId);
              console.log(this.receiverHashId);
              
             if( (element.senderInfo.hash_id == this.senderHashId && element.receiverInfo.hash_id == this.receiverHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)) || (element.senderInfo.hash_id== this.receiverHashId && element.receiverInfo.hash_id == this.senderHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID))){
              this.previousChatHash = element.hash_id
             }
              
            }
          });
          console.log(this.previousChatHash);
          
        }
        this.loaderservice.showLoader = false
        this._modelRef.open(EmployeeChatComponent, {
          width: "500px",
          panelClass: 'custom-dialog-container',
          data: {
            title: this.employeeData[0].employee_name,
            ref: this._modelRef,
            previousChatHash: this.previousChatHash,
            employeeImage: this.employeeData[0].employee_thumb_image,
            employeeHash: this.employeeData[0].profile_hash_id
          },
        });
      }
      // if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MESSAGE_THREAD){
      //   if(resdata.result){
      //     resdata.result = typeof resdata.result == 'string' ? JSON.parse(resdata.result): resdata.result
      //     this.previousChatHash = resdata.result.hash_id
      //      this.apiservice.getMessagesByIDForEmployee()
          
      //   }
      // }
      if(resdata.responseType == SM_CONSTANTS.RESULT_API_UPDATE_EMPLOYEE_INFO){
        if(resdata.result){
          if(this.deleting){
            this.deleting = false
            this.loaderservice.showLoader = false
            this.router.navigate(['../'], {relativeTo: this.route, queryParams: {entityHash: this.entityHash}}, );
          }
        }
      }
      if(resdata.responseType == SM_CONSTANTS.RESULT_API_SET_EMPLOYEE_ACTIVATION_STATUS){
        if(resdata.result){
            // this.loaderservice.showLoader = false
            this.apiservice.getEmployeeDetails(this.employeeHash)
        }
      }
    })
  }
  loader: boolean = false
  employeeHash: any
  entityHash: any
  apisub: Subscription
  ngOnInit(): void {
    this.loader = true
    this.loaderservice.showLoader = true
    this.route.queryParams.subscribe(data => {
      this.employeeHash = data.employeeHash
      this.entityHash = data.entityHash
      this.apiservice.getEmployeeFeatureWiseCounts(this.employeeHash)
    })
  }

  employeeplan() {
    this.router.navigate(["current-plan"], {relativeTo: this.route, queryParamsHandling: 'preserve'});
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
  openSalary(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "salary"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openSalarySettings(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "salary-settings"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openCredits(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "pay-credits"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openDutyLogs(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "duty-logs"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openCurrentPlan(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "current-plan"], {
      queryParamsHandling: 'preserve' , 
    });
  }
   openaccesscontrol(){
 this.router.navigate(["/businesses", "details", "employees", "employee-details", "access-control"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openMessages(){
    this.loaderservice.showLoader = true
    this.apiservice.getMessagesByIDForEmployee()
    
  }
  setEmployeeStatus(status:any){
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to ' + (status == 0 ? 'de-activate' : 'activate')  + ' this employee?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let obj = {
          "employeeHash": this.employeeHash, 
          "entityHash": this.entityHash, 
          "ownerAccountHash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), 
          "status": status
        }
    
        this.loaderservice.showLoader = true
        this.apiservice.setEmployeeActivationStatus(obj)
      }
    })
  }
  editEmployee(item:any){
    let dialogref = this._modelRef.open(AddNewEmployeeComponent, {
      width: '500px',
      data: {
        title: 'Edit Employee',
        ref: this._modelRef,
        data: item
      },
    });
    dialogref.afterClosed().subscribe(res =>{
      if(res){
        this.loaderservice.showLoader = true
        this.apiservice.getEmployeeDetails(this.employeeHash)
      }
    })
  }
  deleting: boolean = false
  deleteEmployee(){
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Employee delete warning!',
        message : 'Are you sure you want to remove this employee?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        this.loaderservice.showLoader = true
        this.deleting = true
        let data = {
          employeeInfo: {
              isDelete: 1,
              date_of_exit: this.formatDate() 
          }
      }
    
      this.apiservice.updateEmployeeInfo(this.employeeData[0].employee_hash_id,data)
      }
    })
    
  }

    formatDate() {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = new Date().toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);

  return curdate
  
    // // Split the date string by `/`
    // const parts = dateStr.split('/');
  
    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');
  
    // // Return the formatted date string
    // return newDateStr;
  }
 
}
